import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function expenseCategoryDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/expense/category/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
